import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ReasonCodeState } from './reason-code.state';
import { ReasonCodeInitialState, ReasonCodeLoad } from './reason-code.actions';
import { SetInitialStateFacade } from '../../../../common';
import { FilterPopupChipsModel, FilterPopupChipsFacade } from '../models/filter-popup-chips.model';

@Injectable()
export class ReasonCodeFacade implements FilterPopupChipsFacade, SetInitialStateFacade {
  items$: Observable<FilterPopupChipsModel[]> = this.store.select(ReasonCodeState.getReasonCode);
  loaded$: Observable<boolean> = this.store.select(ReasonCodeState.getLoaded);

  constructor(private store: Store) {}

  load(): void {
    this.store.dispatch(new ReasonCodeLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new ReasonCodeInitialState());
  }
}
